import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const appleMusic: MusicService = {
  id: 'apple-music',
  name: 'Apple Music',
  shortName: 'Apple Music',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: true,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#B166CC',
    label: '#AA6DC9',
    background: '#7f7685',
  },
  importerID: ImporterID.AppleMusic,
  musicAPIID: MusicAPIIntegrationID.AppleMusic,
  linkType: 'applemusic',
  assets: {
    logo: { light: 'apple-light.svg', dark: 'apple-dark.svg' },
    logoPadding: { light: 'apple-light-padding.svg', dark: 'apple-dark-padding.svg' },
    logoColor: { light: 'apple-color-light.svg', dark: 'apple-color-dark.svg' },
    logoColorPadding: {
      light: 'apple-color-light-padding.svg',
      dark: 'apple-color-dark-padding.svg',
    },
    logoOnBackground: 'apple-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.appleMusicWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: false,
    doesSupportRemovingPlaylists: false,
    doesSupportRemovingTracks: false,
    doesSupportMovingTracks: false,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: false,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: false,
    doesReturnUserCountry: true,
    maxLimit: 25,
  },
};
